import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { tap } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const _router = inject(Router);
  const _authService = inject(AuthService);

  return _authService.isLoggedIn.pipe(
    tap(isLoggedIn => {

      if (!isLoggedIn) {
        _router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      }
    })
  );
};
